import './iframe.scss';

(function () {
    const $$iframes = document.querySelectorAll('[data-iframe]');

    window.addEventListener('message', function (event) {
        $$iframes.forEach((iframe) => {
            const originOk = event.origin === new URL(iframe.src).origin;
            const sourceOk = event.source === iframe.contentWindow;
            if (!originOk || !sourceOk) return;
            if (event.data && event.data[0] === 'setHeight') {
                iframe.style.height = event.data[1] + 'px';
            }
        });
    }, false);
})();
